import React from "react";
import { Paper } from "@mui/material";

interface ActionRibbonProps {
  title: string;
  description: string;
  action?: React.ReactNode;
  testId?: string;
  className?: string;
}

const ActionRibbon: React.FC<ActionRibbonProps> = ({
  title,
  description,
  action,
  testId = "action-ribbon",
  className = "",
}) => {
  return (
    <Paper
      variant="outlined"
      className={className}
      sx={{
        borderRadius: "12px !important",
        backgroundColor: "#F7F8FA !important",
        overflow: "hidden",
      }}
    >
      <div
        data-testid={testId}
        className="flex flex-col gap-4 p-4 md:flex-row md:items-center md:justify-between md:p-6"
      >
        <div>
          <p className="font-bold text-[20px] text-[#31343B] leading-[28px]">{title}</p>
          <p className="mt-2 font-normal text-[16px] text-[#646A77] leading-[24px]">
            {description}
          </p>
        </div>
        {action ? <div className="shrink-0">{action}</div> : null}
      </div>
    </Paper>
  );
};

export default ActionRibbon;
